import { MUTATIONS } from './constants'
import { getDefaultState } from './state'

export const mutations = {
  [MUTATIONS.SET_LOADING] (state, { key, flag }) {
    if (!state[key]) {
      throw new Error('[MUTATIONS.SET_LOCATIONS] invalid key not present in state', key)
    }
    state[key].meta = { ...state[key].meta, loading: flag }
  },
  [MUTATIONS.SET_LOCATIONS] (state, { reset, key, query, meta, data }) {
    if (!state[key]) {
      throw new Error('[MUTATIONS.SET_LOCATIONS] invalid key not present in state', key)
    }
    state[key] = {
      query: query || state[key].query,
      meta: { ...state[key].meta, ...meta, loading: false },
      data: (reset ? [] : state[key].data).concat(data)
    }
  },
  [MUTATIONS.CLEAR_LOCATIONS] (state) {
    const defaultState = getDefaultState()
    Object.assign(state, defaultState)
  },
  [MUTATIONS.TOGGLE_VIEWPORT_FILTER] (state, flag) {
    if (flag) {
      state.viewportFilter.enabled = true
    } else {
      state.viewportFilter = getDefaultState().viewportFilter
    }
  },
  [MUTATIONS.SET_VIEWPORT_DATA] (state, data) {
    if (data.enabled !== false) {
      data.enabled = true
    }
    state.viewportFilter = { ...state.viewportFilter, ...data }
  }
}
